import type { ReactNode } from 'react';
import type { InterviewType } from '@/types/interview';
import type { TabKey } from '@/components/shared/interviews-revamp/component/InterviewTabs';

export interface CollectScoreCardDrawerApplication {
  id?: number;
  ats_job?: {
    id?: number;
    can_edit?: boolean;
  };
}

export interface CollectScoreCardDrawerParams {
  ats_interview_id?: string | number;
  /** Review activity id when collecting scorecards for a planned review (non-interview) */
  ats_review_id?: string | number;
}

export interface CollectScoreCardDrawerAppData {
  id?: number;
  transcript_status?: string;
  [key: string]: unknown;
}

export interface CollectScoreCardScorecardShape {
  id?: number;
  status?: string;
  questions?: Array<{ question?: unknown }>;
  record?: {
    id?: number;
    can_view_interview?: boolean;
    ext_interview_record?: { ext_interview_report_url?: string };
  };
  reviewer?: { id?: number };
}

export interface CollectScoreCardDrawerV1RestProps {
  onNext?: () => void;
  onPrev?: () => void;
  showNavButtons?: boolean;
  scorecards?: Array<{ id: number }>;
  headerAddons?: ReactNode;
}

export interface CollectScoreCardDrawerV1Props extends CollectScoreCardDrawerV1RestProps {
  isOpen?: boolean;
  onClose?: () => void;
  application?: CollectScoreCardDrawerApplication;
  onSuccess?: () => void;
  params?: CollectScoreCardDrawerParams;
  showOnlyCurrUser?: boolean;
  canFillForOthers?: boolean;
  scoreCardID?: number | string | null;
  scorecard?: CollectScoreCardScorecardShape | null;
  viewSc?: boolean;
  appData?: CollectScoreCardDrawerAppData;
  isViewOnly?: boolean;
  isDefaultEdit?: boolean;
  isInterview?: boolean;
  interviewId?: string | number;
  showCandidateLink?: boolean;
  isCurrent?: boolean;
}

export interface DrawerFooterSectionProps {
  onClose: () => void;
  onSubmitClick: () => void;
  isSubmitting: boolean;
  isSaved: boolean;
}

export interface DrawerRightSectionProps {
  interview: InterviewType;
  interviewId?: string | number;
}

export interface DrawerRightSectionWithQueryProps {
  interviewId?: string | number;
}

export const TRANSCRIPT_TABS: TabKey[] = ['summary', 'recording'];

export interface ScoreCardDrawerFormRef {
  submitForm: () => void;
  errors?: Record<string, string>;
}
